"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.MagnetometerStatus = void 0;
var MagnetometerStatus;
(function (MagnetometerStatus) {
    MagnetometerStatus[MagnetometerStatus["NOT_SUPPORTED"] = 0] = "NOT_SUPPORTED";
    MagnetometerStatus[MagnetometerStatus["DISABLED"] = 1] = "DISABLED";
    MagnetometerStatus[MagnetometerStatus["ENABLED"] = 2] = "ENABLED";
})(MagnetometerStatus = exports.MagnetometerStatus || (exports.MagnetometerStatus = {}));
